/* AutoAssignmentAction.js */

"use strict";
const _ = require("lodash");
const AutoAssignVeil = require("./veils/autoassignveil/AutoAssignVeilComponent");
const AutoAssignSummary = require("./veils/autoassignsummary/AutoAssignSummaryComponent");
const ScheduleVeilComponent = require("../../../../lib/actions/veils/schedule/ScheduleVeilComponent");

class AutoAssignmentAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, SiteEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._SiteEntity = SiteEntity;
        this.run = this.run.bind(this);
    }

    run() {
        const selectedSiteIds = _.get(this._activeView.getSelectedSiteIds(), "selectedRows", []);
        const hasSelection = selectedSiteIds.length > 0;

        return this._modalUserFeedback
            .displayCustom(new AutoAssignVeil(this._logger, hasSelection), {dontHide: true})
            .then(({scope, action, name}) => {
                if (action === "schedule") {
                    return this._openSchedule(name);
                }
                return this._runNow(scope, selectedSiteIds);
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    return this._modalUserFeedback.hideDisplayed();
                }
                this._logger.warn({error: err}, "AutoAssignmentAction.run() error");
                return this._modalUserFeedback.displayError(err).catch(_.noop);
            });
    }

    _buildWorkTarget(scope, selectedSiteIds) {
        if (scope === "selection") {
            return {
                category: "entity",
                entityType: "Site",
                method: "multi",
                ids: selectedSiteIds,
            };
        }
        if (scope === "filter") {
            return {
                category: "entity",
                entityType: "Site",
                method: "query",
                query: this._activeView.pagingFeed.getFilterData(),
            };
        }
        return {
            category: "entity",
            entityType: "Site",
            method: "query",
            query: {},
        };
    }

    _runNow(scope, selectedSiteIds) {
        const workTarget = this._buildWorkTarget(scope, selectedSiteIds);
        this._modalUserFeedback.displayLoading({
            message: "Running site auto-assignment...",
        });
        const showProgFunc = (prog) => {
            this._modalUserFeedback.showLoadingProgress(
                `${_.get(prog, "successCount", 0)} of ${_.get(prog, "targetCount", 0)}`
            );
        };
        return this._SiteEntity
            .runAutoAssignMultipleSitesWork(this._activeOrgId, workTarget, {}, {}, showProgFunc)
            .then((result) => {
                this._refreshSiteExplorer();
                return this._modalUserFeedback.displayCustom(
                    new AutoAssignSummary(result, this._logger)
                );
            });
    }

    async _refreshSiteExplorer() {
        try {
            await this._activeView.pagingFeed.feedUpdate();
        } catch (err) {
            this._logger.warn({error: err}, "AutoAssignmentAction: Site Explorer refresh failed");
        }
    }

    _openSchedule(name) {
        const workTarget = {category: "entity", entityType: "Site", method: "query", query: {}};
        return this._modalUserFeedback
            .displayCustom(
                new ScheduleVeilComponent(this._logger, true, "Site auto-assignment - Schedule", {
                    workType: "autoAssignSites",
                }),
                {dontHide: true}
            )
            .then((scheduleDef) => {
                const now = new Date();
                const displayName =
                    name ||
                    "Auto Assignment scheduled on " +
                        now.toLocaleDateString() +
                        " " +
                        now.toLocaleTimeString();
                scheduleDef.workInput.description = displayName;
                return this._SiteEntity.scheduleAutoAssignMultipleSitesWork(
                    this._activeOrgId,
                    displayName,
                    "",
                    scheduleDef.schedule,
                    workTarget,
                    scheduleDef.workInput
                );
            })
            .then(() => {
                return this._modalUserFeedback.hideDisplayed();
            });
    }
}

module.exports = AutoAssignmentAction;

AutoAssignmentAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.Site",
];

AutoAssignmentAction.$displayDetails = {
    type: "Action",
    name: "AutoAssignmentAction",
    icon: "site.auto_assign",
    shown: true,
    title: "Run site auto-assignment",
    order: 13,
};
